import {
  SET_INTEGRATIONS,
  REPLACE_INTEGRATION,
  REMOVE_INTEGRATION
} from './mutationTypes';
import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';

export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_INTEGRATIONS](state, integrations) {
    state.integrations = integrations;
  },
  [REPLACE_INTEGRATION](state, integration) {
    let index = state.integrations.findIndex(i => i.id === integration.id);
    if (index >= 0) {
      state.integrations.splice(index, 1, integration);
    }
  },
  [REMOVE_INTEGRATION](state, integration) {
    state.integrations = state.integrations.filter(item => item.id !== integration.id);
  },
};